module.exports = __webpack_public_path__ + "js/0.c9bef46a.worker.js"